import { render } from "./GeneralSettings.vue?vue&type=template&id=2f8b54fa&scoped=true"
import script from "./GeneralSettings.vue?vue&type=script&lang=js"
export * from "./GeneralSettings.vue?vue&type=script&lang=js"

import "./GeneralSettings.vue?vue&type=style&index=0&id=2f8b54fa&scoped=true&lang=css"
import "./GeneralSettings.vue?vue&type=style&index=1&id=2f8b54fa&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8b54fa"]])

export default __exports__